function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "settings",
  transform: "translate(-3.517 -3.517)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_36",
  "data-name": "Trazado 36",
  d: "M124.066,121a1.842,1.842,0,0,0-1.734,1.226H121v1.226h1.332a1.839,1.839,0,0,0,3.468,0h6.237v-1.226H125.8A1.842,1.842,0,0,0,124.066,121Zm0,2.453a.613.613,0,1,1,.613-.613A.614.614,0,0,1,124.066,123.453Z",
  transform: "translate(-117.483 -117.483)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_37",
  "data-name": "Trazado 37",
  d: "M128.971,211a1.842,1.842,0,0,0-1.734,1.226H121v1.226h6.237a1.839,1.839,0,0,0,3.468,0h1.332v-1.226h-1.332A1.842,1.842,0,0,0,128.971,211Zm0,2.453a.613.613,0,1,1,.613-.613A.614.614,0,0,1,128.971,213.453Z",
  transform: "translate(-117.483 -203.803)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_38",
  "data-name": "Trazado 38",
  d: "M124.066,301a1.843,1.843,0,0,0-1.734,1.226H121v1.226h1.332a1.839,1.839,0,0,0,3.468,0h6.237v-1.226H125.8A1.843,1.843,0,0,0,124.066,301Zm0,2.453a.613.613,0,1,1,.613-.613A.614.614,0,0,1,124.066,303.453Z",
  transform: "translate(-117.483 -290.124)"
}));

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.037,
    height: 11.037,
    viewBox: "0 0 11.037 11.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.c0fe60a9.svg";
export { ForwardRef as ReactComponent };